import React, { useEffect, useState } from 'react'
import ListGroup from '../../userPages/partials/ListGroup'
import UserHero from '../../userPages/partials/UserHero'
import { MdDeleteForever } from "react-icons/md";
import { FaFrownOpen } from "react-icons/fa";
import toast from 'react-hot-toast';
import UserAccount from '../../userPages/partials/UserAccount';

export default   function User () {
    let [data,setData] = useState([])



async function deleteData(_id) {

    
   if(window.confirm("Are You Sure to Delete that Item :")){
    let response = await fetch(`/api/user/`+ _id,{
        method:"DELETE",
        headers:{
            "content-type" : "application/json"
        },
        body: JSON.stringify({...data})
    })
    response = await response.json()
    
    if(response.result ==="Done"){
        toast.success("Delete Successfully")
        setData(response)
    }
   }
}



async function getApiData() {
    let response = await fetch("/api/user" , {
           method :"GET",
           headers:{
            "content-type":"application/json"
           }
    })

    response = await response.json()
    
    
    if(response.result ==="Done"){
        setData(response.data)

    }
    
}



useEffect(()=>{
    getApiData()
} ,[data?.length])
  return (
    <>
    <UserHero/>
       <div className="container">
            <UserAccount/>
                <div className="row my-3">
                 
                    <ListGroup/>
                  
                  <div className="col-md-8">
         <h1 className=' testimonials-h1 text-light text-center p-2' style={{background:"#"}}>User Table </h1>
         <div className="table-responsive">
             {
                data.length?

                <table className='table table-bordered responsive'>
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Address</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        data.map((item,index)=>{
                            return <tr key={index}>
                                <td>{item._id}</td>
                                <td>{item.name}</td>
                                <td>{item.email}</td>
                                <td>{item.phone}</td>
                                <td>{item.address}</td>
                                
                                <td>
                               
                                <MdDeleteForever className='testimonil-table-btn' style={{height:"30", width:"50", }} onClick={() => deleteData(item._id)} />
                            
                                </td>

                            </tr>
                        })
                    }
                </tbody>
              </table>
              :
              <div className="not-testinomonil">
                <h3>Sorry! <FaFrownOpen />  User Record Not Found!!</h3>
                
              </div>
             }
            
                  </div>
              </div>
              </div>
       </div>
    </>
  )
}
